var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { frameAncestorsToPostMessageOrigins } from '../../../../clearstep/util/AppHelpers';
import { Flows } from '../../../../Widget/utils/Flows';
import { BasePartner } from '../BasePartner';
var CorewellHealthPartner = /** @class */ (function (_super) {
    __extends(CorewellHealthPartner, _super);
    function CorewellHealthPartner() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.widgetSearchConfig = function () { return ({
            workflow: Flows.SEARCH_WORKFLOWS,
            queryParamKey: 'initialResponse',
        }); };
        _this.postMessageRecipients = function () { return ({
            // For SPA, where the widget reloads due to back navigation, but the parent page does not reload
            // So we must manually trigger requesting widget dimensions from widgetScript.js to ensure we
            // know mobile vs. desktop
            requestWidgetDimensionsOnLoad: frameAncestorsToPostMessageOrigins(),
        }); };
        return _this;
    }
    return CorewellHealthPartner;
}(BasePartner));
export { CorewellHealthPartner };
